export default [
    // *--------- FENCING --------------------------------*
    {
        path: '/railway-structure/fencing/list',
        name: 'railway_structure-fencing-list',
        component: () => import('@/views/apps/railway_structure/fencing/views/List.vue'),
        meta: {
            resource: 'fencing',
            action: 'read',
            pageTitle: 'Торцевые ограждения',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Торцевые ограждения',
                  active: true,
                },
            ],
        },
    },
    {
        path: '/railway-structure/fencing/view/:id',
        name: 'railway_structure-fencing-view',
        component: () => import('@/views/apps/railway_structure/fencing/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Торцевые ограждения',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Торцевые ограждения',
                    to: {
                        name: 'railway_structure-fencing-list'
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
